<div class="template-box">
    <ng-content></ng-content>
</div>

